import React, { useContext } from "react";
export var AuthContext = React.createContext(void 0);
export var AuthContextInternal = React.createContext(void 0);
export var useAuthInternal = function () {
  var authInternal = useContext(AuthContextInternal);
  if (!authInternal) throw new Error("useAuthInternal must be used within AuthProvider");
  return authInternal;
};